import React from 'react';
import { ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { CartConfirmationTickIcon } from 'components/icons';
import { AlertBannerProps } from './types';

const AlertBanner = ({
  children,
  className,
  alertType = 'warning',
  'data-ffid': dataFfid,
  'icon-ffid': iconFfid,
}: React.PropsWithChildren<AlertBannerProps>) => {
  const containerClassName = clsx(
    'flex items-center justify-center gap-16 rounded-lg border py-8 px-16',
    alertType === 'warning' && 'border-[#FBC02D] bg-[#FFFBEC]',
    alertType === 'error' && 'border-[#DB0000] bg-[#FFEFEF]',
    alertType === 'success' && 'border-[#67AC1E] bg-[#F1FFE3]',
    alertType === 'delete' && 'mx-8 text-[#DB0000]',
    className,
  );
  const textClassName = clsx(
    'aspect-square min-w-24',
    alertType === 'warning' && 'text-[#FBC02D]',
    alertType === 'error' && 'text-[#DB0000]',
    alertType === 'success' && 'text-[#67AC1E]',
  );
  let Icon = null;
  switch (alertType) {
    case 'warning':
      Icon = <InformationCircleIcon />;
      break;
    case 'success':
      Icon = <CartConfirmationTickIcon dimension={24} />;
      break;
    case 'error':
      Icon = <CartConfirmationTickIcon dimension={24} />;
      break;
    case 'delete':
      Icon = <ExclamationTriangleIcon />;
      break;
    default:
  }

  return (
    <div className={containerClassName} data-ffid={dataFfid}>
      <div className={textClassName} data-ffid={iconFfid}>
        {Icon}
      </div>
      <div className="w-full break-words text-12">{children}</div>
    </div>
  );
};

export default AlertBanner;
